var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-service vh100"},[_vm._m(0),_c('div',{staticClass:"service-code"},[_c('img',{attrs:{"src":require("../assets/images/code-image.png"),"alt":""}}),_c('div',{staticClass:"code-img"},[_c('img',{attrs:{"src":_vm.qrCode,"alt":""}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-text"},[_c('p',[_vm._v("AI课程需要在小程序进行学习")]),_c('p',[_vm._v("扫描下方二维码立即学习")])])
}]

export { render, staticRenderFns }